import type {CollectionSubType, Concept} from 'types';
import {CollectionSubTypes} from 'types';

export const isCollectionSubType = (
  entity: Concept | undefined,
): entity is CollectionSubType => {
  return !!entity && CollectionSubTypes.includes(entity as CollectionSubType);
};
